import React, { useEffect, useRef, useState } from "react";
import "../../styles/SponsorSlide.scss";

interface SponsorItem {
  logo: string;
  alt: string;
}

const SponsorSlide: React.FC = () => {
  const sliderRef = useRef<HTMLDivElement | null>(null);
  const directionRef = useRef(-1);
  const [sponsors, setSponsors] = useState<SponsorItem[]>([]);

  useEffect(() => {
    fetch("/resources/sponsor.json")
      .then((res) => res.json())
      .then((data) => setSponsors(data.sponsor || []))
      .catch(console.error);
  }, []);

  useEffect(() => {
    const slider = sliderRef.current;
    if (!slider) return;

    let animationFrameId: number;
    let lastTime = performance.now();
    const directionChangeInterval = 10000;
    let nextDirectionChange = lastTime + directionChangeInterval;

    const slide = (time: number) => {
      const deltaTime = time - lastTime;
      lastTime = time;

      slider.scrollLeft += 0.1 * deltaTime * directionRef.current;

      if (time >= nextDirectionChange) {
        directionRef.current *= -1;
        nextDirectionChange = time + directionChangeInterval;
      }

      animationFrameId = requestAnimationFrame(slide);
    };

    animationFrameId = requestAnimationFrame(slide);
    return () => cancelAnimationFrame(animationFrameId);
  }, []);

  return (
    <div className="sponsor-slider" ref={sliderRef}>
      {[...sponsors, ...sponsors].map((item, i) => (
        <img
          key={i}
          src={item.logo}
          alt={item.alt}
          className="sponsor-logo"
        />
      ))}
    </div>
  );
};

export default SponsorSlide;
